import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { EDIT_CREATE_SURVEYS } from './constants';
import {
  EditCreateSurveysDataActionTypes,
  EditCreateSurveysError,
  EditCreateSurveysState,
  EditCreateSurveysSuccess,
} from './types';

const initialState: EditCreateSurveysState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: EditCreateSurveysDataActionTypes,
  ): EditCreateSurveysState => {
    switch (action.type) {
      case EDIT_CREATE_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case EDIT_CREATE_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as EditCreateSurveysSuccess).payload;
        break;
      }
      case EDIT_CREATE_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as EditCreateSurveysError).error;
        break;
      }
      case EDIT_CREATE_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
